module.exports = __webpack_public_path__ + "static/img/1.59eecb71.png";